// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FormatBoldIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FormatBoldIcon" ref={forwardedRef} {...props}>
      <path d="M5.5 3h4.444c1.451 0 2.573.323 3.353.968S14.47 5.5 14.47 6.618q0 1.119-.541 1.936c-.36.544-.88.967-1.562 1.26-.68.292-1.501.443-2.452.443l.4-.978c1.041 0 1.932.152 2.673.464.74.312 1.291.746 1.682 1.32.39.575.58 1.25.58 2.036 0 .787-.19 1.472-.58 2.057-.38.584-.931 1.038-1.632 1.36S11.505 17 10.565 17H5.499zm.95 11.752h3.814c.821 0 1.442-.171 1.862-.504s.63-.816.63-1.44c0-.626-.22-1.13-.64-1.473q-.647-.514-1.852-.514H7.051V8.827h3.173c.61 0 1.071-.172 1.392-.524.32-.343.48-.797.48-1.34 0-.545-.17-.979-.51-1.291s-.851-.474-1.512-.474H6.851L7.98 4.2v11.753z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FormatBoldIcon = /* @__PURE__ */ Object.assign(
  FormatBoldIconComponent,
  { displayName: 'FormatBoldIcon' },
);
